import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, BellIcon, UserIcon, HelpCircleIcon, ArrowRightIcon, LockIcon, InfoIcon } from 'lucide-react';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
interface SettingsScreenProps {
  onManageConsents: () => void;
  pendingConsentsCount?: number;
}
export function SettingsScreen({
  onManageConsents,
  pendingConsentsCount = 0
}: SettingsScreenProps) {
  const settingsSections = [{
    title: 'Account',
    items: [{
      icon: UserIcon,
      label: 'Profile',
      description: 'Manage your personal information',
      onClick: () => console.log('Profile clicked')
    }, {
      icon: BellIcon,
      label: 'Notifications',
      description: 'Control alerts and reminders',
      onClick: () => console.log('Notifications clicked')
    }]
  }, {
    title: 'Open Finance',
    items: [{
      icon: ShieldCheckIcon,
      label: 'Manage Consents',
      description: 'View and control bank connections',
      badge: pendingConsentsCount,
      onClick: onManageConsents,
      highlight: true
    }, {
      icon: InfoIcon,
      label: 'About Open Finance',
      description: 'Learn how it works and stays secure',
      onClick: () => console.log('About clicked')
    }]
  }, {
    title: 'Security',
    items: [{
      icon: LockIcon,
      label: 'Security Settings',
      description: 'Password and authentication',
      onClick: () => console.log('Security clicked')
    }]
  }, {
    title: 'Support',
    items: [{
      icon: HelpCircleIcon,
      label: 'Help Center',
      description: 'Get answers to common questions',
      onClick: () => console.log('Help clicked')
    }]
  }];
  return <div className="space-y-6" data-id="element-1217">
      {/* Header */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-1218">
        <h1 className="text-2xl font-bold mb-2" style={{
        color: OPENFINANCE_THEME.colors.text,
        fontFamily: OPENFINANCE_THEME.fonts.heading
      }} data-id="element-1219">
          Settings
        </h1>
        <p className="text-sm" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-1220">
          Manage your account and preferences
        </p>
      </motion.div>

      {/* Settings Sections */}
      {settingsSections.map((section, sectionIndex) => <motion.div key={section.title} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1 + sectionIndex * 0.1
    }} data-id="element-1221">
          <h2 className="text-sm font-bold uppercase tracking-wide mb-3" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-1222">
            {section.title}
          </h2>

          <div className="bg-white border-2 rounded-2xl overflow-hidden" style={{
        borderColor: OPENFINANCE_THEME.colors.border
      }} data-id="element-1223">
            {section.items.map((item, itemIndex) => {
          const Icon = item.icon;
          const isLast = itemIndex === section.items.length - 1;
          return <button key={item.label} onClick={item.onClick} className="w-full flex items-center gap-4 p-5 text-left transition-colors hover:bg-gray-50" style={{
            borderBottom: isLast ? 'none' : `2px solid ${OPENFINANCE_THEME.colors.borderLight}`
          }} data-id="element-1224">
                  {/* Icon */}
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: item.highlight ? OPENFINANCE_THEME.colors.primary500 + '15' : OPENFINANCE_THEME.colors.borderLight
            }} data-id="element-1225">
                    <Icon className="w-5 h-5" style={{
                color: item.highlight ? OPENFINANCE_THEME.colors.primary500 : OPENFINANCE_THEME.colors.textMuted
              }} data-id="element-1226" />
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-1227">
                    <div className="flex items-center gap-2 mb-1" data-id="element-1228">
                      <span className="text-base font-semibold" style={{
                  color: OPENFINANCE_THEME.colors.text,
                  fontFamily: OPENFINANCE_THEME.fonts.heading
                }} data-id="element-1229">
                        {item.label}
                      </span>
                      {item.badge !== undefined && item.badge > 0 && <span className="px-2 py-0.5 rounded-full text-xs font-bold text-white" style={{
                  backgroundColor: OPENFINANCE_THEME.colors.error
                }} data-id="element-1230">
                          {item.badge}
                        </span>}
                    </div>
                    <p className="text-sm" style={{
                color: OPENFINANCE_THEME.colors.textMuted
              }} data-id="element-1231">
                      {item.description}
                    </p>
                  </div>

                  {/* Arrow */}
                  <ArrowRightIcon className="w-5 h-5 flex-shrink-0" style={{
              color: OPENFINANCE_THEME.colors.textMuted
            }} data-id="element-1232" />
                </button>;
        })}
          </div>
        </motion.div>)}

      {/* App Info */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.5
    }} className="text-center pt-4" data-id="element-1233">
        <p className="text-xs mb-1" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-1234">
          VeloX Personal Finance
        </p>
        <p className="text-xs" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-1235">
          Version 1.0.0 • Powered by Open Finance
        </p>
      </motion.div>
    </div>;
}